/**
 * Enum-like object containing all valid stages for a course.
 * This helps maintain consistency and provides autocomplete support.
 * @readonly
 * @enum {string}
 */
export const CourseStage = Object.freeze({
  /** Initial stage to collect user background information */
  COLLECT_BACKGROUND: "COLLECT_BACKGROUND",

  /** Stage for assessing the learner's current level */
  ASSESS_LEARNER: "ASSESS_LEARNER",

  /** Stage for building the personalized learning plan */
  BUILD_PLAN: "BUILD_PLAN",

  /** Stage when the plan is ready and lessons are in progress */
  PLAN_IN_PROGRESS: "PLAN_IN_PROGRESS",

  /** Final stage when the course is completed */
  COMPLETED: "COMPLETED",
});
